import axios from "axios";
import cookie from "react-cookies";
import SnackbarUtils from "../components/NotistackPlus";
import { RIMS_COOKIE_STG_CONSTANTS } from "../constants";
import { useConfigStore } from "../store/config";
import { getResolvedTenantId } from "../common/tenant";
import { getApiGateway } from "../common/utils";
// import { toast } from 'react-toastify';

// const isPrd = process.env.NODE_ENV === 'production';

//export const basicUrl = isPrd ? 'https://88xqd6km6b.execute-api.us-east-1.amazonaws.com' : 'http://localhost:3000/api'

export const basicUrl = getApiGateway();
const refreshURL = "/common-auth/refresh";
const service = axios.create({
  baseURL: basicUrl,
});

service.interceptors.request.use(
  (config) => {
    const language = useConfigStore.getState()?.language;
    const languageformat = language === "en" ? "" : language;
    const token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
    // // @ts-ignore
    // if (!token && config.url?.indexOf(AUTH_PREFIX) === -1) {
    //   window.location.href = `${redirectURL}?redirect=${window.location.origin}`;
    // }
    token
      ? (config.headers = {
          "Content-Type":
            config.responseType === "arraybuffer" &&
            JSON.stringify(config.data) === "{}"
              ? "application/octet-stream;charset=utf-8"
              : "application/json;charset=utf-8",
          Authorization: `Bearer ${token}`,
          "X-Tenant-Id": getResolvedTenantId(config.url),
          "Accept-Language": languageformat || "",
        })
      : (config.headers = {
          "Content-Type": "application/json;charset=utf-8",
          "Accept-Language": languageformat || "",
        });
    // : (config.headers = {
    //     "Content-Type": "application/json;charset=utf-8",
    //   });
    // config.data = QS.stringify(config.data)
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response: any) => {
    if (response.config.responseType !== "arraybuffer") {
      if (response.status) {
        switch (response.status) {
          case 200:
            return response.data;
          case 400:
          case 401:
          case 403:
            return;
          default:
            console.log("error", response.data.msg);
        }
      }
    } else {
      return response;
    }
  },
  (err) => {
    if (err.config?.url?.indexOf(refreshURL) > -1) {
      return;
    } else {
      switch (err.response.status) {
        case 401:
          break;
        case 403:
          break;
        case 500:
            const token = cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN);
            if (token) {
            SnackbarUtils.error(
              "There is something wrong with server, please try again later"
            );
          }
          break;
        default:
      }
    }
    return Promise.reject(err);
  }
);

export default service;
